import React from "react";
import { connect } from "react-redux";
import ReactEChartsCore from 'echarts-for-react/lib/core';
import * as echarts from 'echarts/core';
import { PieChart } from 'echarts/charts';
import { GridComponent, TooltipComponent, TitleComponent, LegendComponent } from 'echarts/components';
import { CanvasRenderer } from 'echarts/renderers';

echarts.use(
    [TitleComponent, LegendComponent, TooltipComponent, GridComponent, PieChart, CanvasRenderer]
);

class PositionProportionEChart extends React.Component {
    constructor(props) {
        super(props);
        props.innerRef(this);
        const textColor = this.props.theme === 'light' ? '#000' : '#fff'
        this.state = {
          option: {
            tooltip: this.props.tooltip ? this.props.tooltip : {
              trigger: 'item'
            },
            legend:  this.props.legend ?  this.props.legend : null,
                series: [
                  {
                    name: '',
                    type: 'pie',
                    top:this.props.top ? this.props.top : null,
                    radius:this.props.radius ? this.props.radius : ['30%', '45%'],
                    label: this.props.label ? this.props.label: {
                      formatter: '{d}%',
                      color: textColor
                    },
                    emphasis: {
                      itemStyle: {
                        shadowBlur: 10,
                        shadowOffsetX: 0,
                        shadowColor: 'rgba(0, 0, 0, 0.5)'
                      }
                    },
                    data: this.props.data,
                    labelLine: this.props.labelLine ? this.props.labelLine :{
                      normal: {
                        show:true,
                        length:5
                      },           
                    },
                  }
                ]
              },
        }
    }

    componentDidUpdate(prevProps) {
      if (this.props.theme !== prevProps.theme) {
        const textColor = this.props.theme === 'light' ? '#000' : '#fff'
        const deepOption = JSON.parse(JSON.stringify(this.state.option))
        deepOption.series[0].label.color = textColor
        this.setState({ option: deepOption })
      }
      if (this.props.tooltip !== prevProps.tooltip){
        this.setOption();
      }
    }

    setOption = () => {
      const option = {
        tooltip: this.props.tooltip ? this.props.tooltip : {
          trigger: 'item'
        },
        legend:  this.props.legend ?  this.props.legend : null,
        series: [
          {
            name: '',
            type: 'pie',
            top:this.props.top ? this.props.top : null,
            radius:this.props.radius ? this.props.radius : ['30%', '45%'],
            label: this.props.label ? this.props.label: {
              formatter: '{d}%',
              color: textColor
            },
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            },
            data: this.props.data,
            labelLine: this.props.labelLine ? this.props.labelLine :{
              normal: {
                show:true,
                length:5
              },           
            },
          }
        ]
      }
      this.setState({
        option: option
      })
    }

    colorArr = (seriesIndex) => {
        return seriesIndex.data.bgColor
      }

    setEChartPieData = (data) => {
        if (this.echartsElementRef) {
          this.echartsElementRef.getEchartsInstance().setOption(data, false, true);
        }
    }

    render() {
        const { language } = this.props;
        return (
            <ReactEChartsCore
                ref={e => this.echartsElementRef = e}
                echarts={echarts}
                option={this.state.option}
                theme={"theme_name"}
            />
        )
      }
}

PositionProportionEChart.defaultProps = {
    data: []
}
  
export default connect(
    (state) => ({
        language: state.app.language,
        theme: state.app.theme,
        currentTradingAccount: state.trade.currentTradingAccount,
    }),
    (dispatch) => ({

    })
)(PositionProportionEChart);
  